<template>
  <header>
    <div class="inner">
      <div class="fl">
        <img class="logo" src="@/assets/img/logo3.png" alt="" />
      </div>
      <nav class="fr">
        <router-link to="/" class="link" :class="{ active: nave.ind === 0 }">
          <span>首页</span>
        </router-link>
        <router-link
          to="/down"
          class="link"
          :class="{ active: nave.ind === 1 }"
        >
          <span>下载客户端 | </span>
        </router-link>
        <img class="avator" :src="userInfo.avatar" alt="" />
        {{ userInfo.name }}
        <span class="loginOut" @click="loginOut">退出登录</span>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import page_mx from "@/mixin/page_mx";
import jsCookie from "js-cookie";
import config from "../../config";

import store from "../store";

export default {
  mixins: [page_mx],

  data() {
    return {};
  },
  computed: mapState({
    nave: (state) => state.main.nave,
  }),
  methods: {
    loginOut() {
      this.$Tools.confirm("确定退出重新登录吗？").then(async () => {
        await this.$api.ums.user.user_signOut.delete({
          unbind: "是",
        });
        const temp = JSON.parse(jsCookie.get(`${config.NAME}_userInfo`));
        localStorage.removeItem(`${config.NAME}_userInfo_${temp.id}`);
        await store.commit("userInfoUpdate", {});
        this.$router.replace({
          path: "/login",
        });
      });
    },
  },
  created() {
    console.log(this.nave);
  },
};
</script>
<style lang="less" scope>
.fl {
  float: left;
}

.fr {
  float: right;
}

.avator {
  margin: 0 6px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
}

.loginOut {
  margin-left: 20px;
  cursor: pointer;
}

.inner {
  width: 1160px;
  height: 80px;
  overflow: hidden;
  line-height: 80px;
  margin-left: auto;
  margin-right: auto;
}

.logo {
  margin-top: 17px;
}

.fr .link {
  color: #666;
  font-size: 18px;
  margin-left: 40px;
}

.fr .link.active {
  position: relative;
  color: #333;
  font-weight: 600;
}

.fr .link.active::after {
  position: absolute;
  content: "";
  left: 10%;
  bottom: -10px;
  height: 2px;
  width: 80%;
  background-color: #00b861;
}
</style>
